import React from "react";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { useNavigate, useSearchParams } from "react-router-dom";
import OrganisationLayout from "../../components/organisation/layout/OrganisationLayout";
import { FilterMatchMode } from "primereact/api";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import {
  fetchAllCustomers,
  fetchFilteredCustomersAction,
} from "../../store/slices/customer/action";
import GreendotDot from "../../assets/icons/GreenDotIcon.svg";
import { getFromSessionStorage } from "../../utils/browserStorage";
import { toast } from "react-toastify";
import { BiSearchAlt } from "react-icons/bi";
import {
  CustomerAccount,
  CustomerProfile,
} from "../../store/slices/customer/types";
import { getMainProfile } from "../../utils/helper";
import { BaseButton } from "../../components/base";
const CustomersList = () => {
  const { customerData } = useAppSelector((state) => state.customerReducer);

  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );
  const headerStyle = {
    color: "#0C4654",
    fontSize: "0.875rem",
    fontWeight: "500",
    backgroundColor: "transparent",
  };
  const bodyStyle = {
    color: "#0C4654",
    fontSize: "1rem",
    fontWeight: "500",
    backgroundColor: "transparent",
  };

  const dispatch = useAppDispatch();
  let navigate = useNavigate();

  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState(null);

  const [searchParam] = useSearchParams();
  const booking = searchParam.get("booking");

  const [lazyParams, setLazyParams] = useState({
    organisationId: currentOrganisationAccount?.organisationId,
    first: 0,
    rows: 10,
    page: 1,
    filters: {
      global: { value: "", matchMode: FilterMatchMode.CONTAINS },
    },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLazyData(lazyParams);
  }, []);

  const loadLazyData = async (lazyParams: any) => {
    setLoading(true);
    const { payload } = await dispatch(
      fetchFilteredCustomersAction(lazyParams)
    );

    if (payload?.status == 200) {
      setLoading(false);
    } else {
      toast.error(
        "Something went wrong while fetching customers. Pls try again"
      );
      setLoading(false);
    }
  };

  const onPage = (event: any) => {
    setLazyParams({
      filters: lazyParams.filters,
      organisationId: lazyParams.organisationId,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });

    loadLazyData({
      filters: lazyParams.filters,
      organisationId: lazyParams.organisationId,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
  };

  const onSelectionChange = (event: any) => {
    const value = event.value;
    navigate(`/dashboard/customers/${value?._id}`, {
      state: {
        ...lazyParams,
      },
    });
  };

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    if (e.target.value.length >= 3) {
      let _filters = { ...lazyParams.filters };
      _filters["global"].value = value;
      setGlobalFilterValue(value);
      setLazyParams({ ...lazyParams, filters: _filters });
      loadLazyData({
        ...lazyParams,
        filters: _filters,
      });
    }
    if (e.target.value === "") {
      loadLazyData({
        ...lazyParams,
        filters: {
          global: { value: "", matchMode: FilterMatchMode.CONTAINS },
        },
      });
    }
  };

  const fullNameBodyTemplate = (rowData: any) => {
    return (
      <div className="flex items-center">
        <img
          src={GreendotDot}
          alt="green dot icon"
          className="w-[6px] xl:w-[10px] mx-2 flex my-auto"
        />
        <p>
          {getMainProfile(rowData)?.title || ""}{" "}
          {getMainProfile(rowData)?.firstName}{" "}
          {getMainProfile(rowData)?.lastName}{" "}
        </p>
      </div>
    );
  };

  const createdAtBodyTemplate = (rowData: any) =>
    rowData?.createdAt ? (
      <div>
        <span>
          {
            new Date(rowData?.createdAt)
              .toLocaleString("en-GB", { timeZone: "UTC" })
              .split(",")[0]
          }
        </span>
      </div>
    ) : (
      "----------"
    );

  //   const orderCountBodyTemplate = (rowData: any) =>
  //     rowData?.orders ? <p>{rowData?.orders?.length}</p> : "----------";

  const genderBodyTemplate = (rowData: CustomerAccount) => {
    return <>{getMainProfile(rowData)?.gender || "---------"}</>;
  };

  return (
    <>
      <OrganisationLayout>
        <div className="px-3 lg:px-12 mt-5">
          <div className="mb-6">
            <h1 className="text-[#0C4654] font-[500] text-[1.2rem]">
              {booking === "true" ? "Select Booker Account" : "Customers"}
            </h1>
            {booking === "true" && (
              <p className="text-base text-gray-600">
                Select an account to proceed
              </p>
            )}
          </div>

          <div className="bg-[#F2F6FA] rounded px-3 py-6 text-[#0C4654]">
            <div className="w-full flex justify-end mb-4">
              <BaseButton
                text="Add new booker account"
                variant="primary"
                styles="!px-5 !h-10 my-1 !text-[0.875rem] font-bold "
                click={() => navigate("/dashboard/customers/add-new-booker-account")}
              />
            </div>
            <div className="mb-4 px-3">
              <label className="relative">
                <BiSearchAlt
                  className="textbrandColor absolute left-3 top-1"
                  size="1rem"
                />
                <input
                  type="text"
                  className="border p-4 pl-8 rounded-[0.5rem] w-full text-[0.875rem] font-[500] placeholder-[#767B86] focus:outline-none"
                  placeholder="Search"
                  onKeyUp={onGlobalFilterChange}
                />
              </label>
            </div>
            <div className="p-3 mt-2 rounded-[8px]">
              <DataTable
                value={customerData?.data}
                lazy
                paginator
                className="h-full"
                // header={header}
                first={lazyParams?.first}
                rows={lazyParams?.rows}
                totalRecords={customerData?.total}
                onPage={onPage}
                // onSort={onSort}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                dataKey="id"
                rowHover
                sortField={sortField}
                sortOrder={sortOrder}
                scrollable
                onSelectionChange={onSelectionChange}
                loading={loading}
                selectionMode="single"
                responsiveLayout="scroll"
                globalFilterFields={["name", "unit"]}
                emptyMessage="No customers found."
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} customers"
              >
                <Column
                  field="name"
                  header="Full Name"
                  body={fullNameBodyTemplate}
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="gender"
                  header="Gender"
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  body={genderBodyTemplate}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="email"
                  header="Email"
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="mobile"
                  header="Phone Number"
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                    textAlign: "center",
                  }}
                  bodyStyle={bodyStyle}
                />
                <Column
                  field="createdDate"
                  header="Created Date"
                  body={createdAtBodyTemplate}
                  headerStyle={headerStyle}
                  style={{
                    fontWeight: "700",
                    borderBottom: "5px solid #F9FAFB",
                  }}
                  bodyStyle={bodyStyle}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </OrganisationLayout>
    </>
  );
};

export default CustomersList;

// export default WithOrganisationAuth(OrganisationDashboard);
